import React, { Component } from 'react';
import Slider from 'react-slick';
import { Button, Col } from 'reactstrap';
import 'sweetalert2/dist/sweetalert2.css';
import language from '../../../../assets/languages/language';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import Loader from '../../../../common/loader';
import { showSuccess } from '../../../../common/toast';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTFlagged from '../../../Common/CBTFlagged';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';

import { caseCV } from '../../../../common/cbttopnavigationsettings';
import { SecondsToHHMMSS, filterObj } from '../../../../common/constant';
import { clearSelection, highlightString } from '../../../../common/highlightText';
import ViewAnswer from '../../../CFA3/Cfa3EssayQuestions/Layout/ViewAnswer';
import AppRoutes from '../../../config/AppRoutes';
import ViewEssayQuestions from '../Questions/ViewEssayQuestions';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
const longPressDuration = 450;
// var attemptedGrading = [];
class CFA3GradeQuestions extends Component {
  selectionShare;
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      time: {},
      seconds: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: this.props.params.timerStart,
      selectedQuestion: '',
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
      vpCaseLoader: true,
      questionLoader: true,
      totalQuestionCount: 0,
      justification1: '',
      justification2: '',
      userGrading: '',
      selectedIndex: -1,
      attemptedGrading: [],
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
    this.isPathway = this.props.location.pathname.includes(AppRoutes.CFA3_PATHWAY_CBT);
    this.gradeQuestionRoute = this.isPathway
      ? AppRoutes.CFA3_PATHWAY_CBT_GRADE_QUESTIONS
      : AppRoutes.CFA3_CBT_GRADE_QUESTIONS;
    this.finishTestRoute = this.isPathway
      ? AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS_FINISH
      : AppRoutes.CFA3_CBT_QUESTIONS_FINISH;
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidUpdate = async (prevProps, prevState) => {
    // console.log('prevState', prevState.casesData, prevState.userStatsData);

    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (
      prevProps.params.caseOffset !== this.props.params.caseOffset ||
      prevProps.params.quesOffset !== this.props.params.quesOffset
    ) {
      const { id, testid } = this.props.params;
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: id ? parseInt(id) : null,
        test_id: testid,
        type: 'essay_question',
      };
      await this.getGradingQuestions(data);
      await this.getUserStats();
      this.getFlagQuestions();
    }
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    const { id, testid } = this.props.params;
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: id ? parseInt(id) : null,
      test_id: testid,
      type: 'essay_question',
    };
    this.getGradingQuestions(data);
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getMockNamebyId', data).then(
      async (res) => {
        this.setState({
          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        });
      },
    );
    this.getFlagQuestions();
  };

  customizeCaseData = async (data) => {
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getGradingQuestions', data).then(
      (resp) => {
        if (resp.success) {
          if (resp.question && resp.question.length) {
            FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then(
              (resp) => {
                this.setState({
                  isLoading: false,
                  isDataLoading: false,
                  vpCaseLoader: false,
                  questionLoader: false,
                  display_main_loader: 'hide_block',
                });
                let customizeCaseData = resp.question
                  .map((r) => {
                    let tempArr = r.cfa3_cbt_questions.filter((c) =>
                      keys.includes(c.id.toString()),
                    );
                    if (tempArr.length) return { ...r, cfa3_cbt_questions: tempArr };
                  })
                  .filter(Boolean);

                this.setState({
                  casesData: customizeCaseData,
                  selectedQuestionData: customizeCaseData[caseOffset],
                  questionsData:
                    customizeCaseData[caseOffset] &&
                    customizeCaseData[caseOffset].cfa3_cbt_questions
                      ? customizeCaseData[caseOffset].cfa3_cbt_questions
                      : [],
                  selectedCaseQuestionData:
                    customizeCaseData[caseOffset] &&
                    customizeCaseData[caseOffset].cfa3_cbt_questions &&
                    customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset]
                      ? customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset]
                      : [],
                });
              },
            );
          }
        }
      },
    );
  };

  getGradingQuestions = async (data) => {
    this.setState({
      display_main_loader: 'show_block z-index-1000 bg-white',
      vpCaseLoader: true,
      questionLoader: true,
    });
    FD.callAPI(
      `${App_data.backend_api}${
        this.isPathway
          ? '/cfa3PathwayExams/getCFAMockCases'
          : '/cfa3CBTMockExams/getGradingQuestions'
      }`,
      data,
    ).then((resp) => {
      if (resp.success) {
        if (resp.question && resp.question.length) {
          this.getHighlightedText();
          this.getStrikedText();
          this.getUserStats(resp.question);
        }
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });
  };

  changeCase = (questionNumber, index) => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index + 1);
    this.getUserStats();
    this.setState({
      isLoading: true,
    });
    const {
      state: { token, idname },
      props: { params },
    } = this;
    const { id, caseOffset, timer, testid, timerStart, isNegative } = params;
    const data = {
      token,
      idname,
      mock_id: id ? parseInt(id) : null,
      test_id: testid,
      type: 'essay_question',
    };
    if (questionNumber) {
      let pathname = this.gradeQuestionRoute
        .replace(':id', id)
        .replace(':caseno', questionNumber)
        .replace(
          ':questiono',
          casesData[parseInt(caseOffset)] && casesData[parseInt(caseOffset)].cfa3_cbt_questions[0]
            ? casesData[parseInt(caseOffset)].cfa3_cbt_questions[0].id
            : 1,
        )
        .replace(':timer', timer)
        .replace(':testid', testid)
        .replace(':caseOffset', index)
        .replace(':timerStart', timerStart)
        .replace(':isNegative', isNegative)
        .replace(':quesOffset', 0);
      this.setState({
        userGrading: '',
      });
      this.context.router.push(
        {
          pathname,
        },
        this.getGradingQuestions(data),
      );
    }
  };

  getUserStats = async (essayQues = []) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then((resp) => {
      if (resp.success) {
        const { quesOffset, caseOffset } = this.props.params;

        let usersJustifications = resp.data.justification
          ? JSON.parse(resp.data.justification)
          : {};
        let keys = Object.keys(usersJustifications);
        if (essayQues.length) {
          let customizeCaseData = essayQues
            .map((r) => {
              let tempArr = r.cfa3_cbt_questions.filter((c) => keys.includes(c.id.toString()));
              if (tempArr.length) return { ...r, cfa3_cbt_questions: tempArr };
            })
            .filter(Boolean);

          this.setState({
            casesData: customizeCaseData,
            selectedQuestionData: customizeCaseData[caseOffset],
            questionsData:
              customizeCaseData[caseOffset] && customizeCaseData[caseOffset].cfa3_cbt_questions
                ? customizeCaseData[caseOffset].cfa3_cbt_questions
                : [],
            selectedCaseQuestionData:
              customizeCaseData[caseOffset] &&
              customizeCaseData[caseOffset].cfa3_cbt_questions &&
              customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset]
                ? customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset]
                : [],
          });

          this.setState({
            isLoading: false,
            isDataLoading: false,
            vpCaseLoader: false,
            questionLoader: false,
            display_main_loader: 'hide_block',
          });
        }

        this.setState({
          userStatsData: resp.data,
          seconds: resp.data.user_time_value
            ? resp.data.user_time_value
            : parseInt(this.props.params.timer),
          isNegative: resp.data.isNegative,
          attemptedGrading:
            resp.data.attemptedGrading != null ? JSON.parse(resp.data.attemptedGrading) : [],
        });
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };

  changeQuestion = (questionNumber, index) => {
    if (questionNumber) {
      const { id, caseno, timer, testid, caseOffset, isNegative, timerStart } = this.props.params;
      let pathname = this.gradeQuestionRoute
        .replace(':id', id)
        .replace(':caseno', caseno)
        .replace(':questiono', questionNumber)
        .replace(':timer', timer)
        .replace(':testid', testid)
        .replace(':caseOffset', caseOffset)
        .replace(':quesOffset', index)
        .replace(':isNegative', isNegative)
        .replace(':timerStart', timerStart);

      this.setState({
        userGrading: '',
      });
      this.context.router.push({
        pathname,
      });
    }
  };

  getNextCase = (index) => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index);
    this.setState({
      isLoading: true,
    });
    const { id, timer, testid, caseOffset, isNegative, timerStart } = this.props.params;
    let pathname = this.gradeQuestionRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) + 1].id : 1)
      .replace(
        ':questiono',
        casesData[parseInt(caseOffset) + 1] &&
          casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0]
          ? casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0].id
          : 1,
      )
      .replace(':timer', timer)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset ? parseInt(caseOffset) + 1 : 1)
      .replace(':quesOffset', 0)
      .replace(':isNegative', isNegative)
      .replace(':timerStart', timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getPreviousCase = (index) => {
    const { casesData } = this.state;
    this.slider.slickGoTo(index - 2);
    this.setState({
      isLoading: true,
    });
    const { id, timer, testid, caseOffset, isNegative, timerStart } = this.props.params;
    let pathname = this.gradeQuestionRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) - 1].id : 1)
      .replace(
        ':questiono',
        casesData[parseInt(caseOffset) - 1] &&
          casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0]
          ? casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0].id
          : 1,
      )
      .replace(':timer', timer)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset ? parseInt(caseOffset) - 1 : 1)
      .replace(':quesOffset', 0)
      .replace(':isNegative', isNegative)
      .replace(':timerStart', timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getPreviousQuestion = (index) => {
    const { questionsData } = this.state;
    this.setState({ userGrading: '' });
    const { id, quesOffset, timer, testid, caseOffset, isNegative, timerStart } = this.props.params;
    let pathname = this.gradeQuestionRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset)
      .replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) - 1].id : 1)
      .replace(':timer', timer)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset)
      .replace(':quesOffset', quesOffset ? parseInt(quesOffset) - 1 : 1)
      .replace(':isNegative', isNegative)
      .replace(':timerStart', timerStart);

    this.context.router.push({
      pathname,
    });
  };

  getNextQuestion = (index) => {
    const { questionsData } = this.state;
    this.setState({ userGrading: '' });
    const { id, quesOffset, timer, testid, caseOffset, isNegative, timerStart } = this.props.params;
    let pathname = this.gradeQuestionRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset)
      .replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) + 1].id : 1)
      .replace(':timer', timer)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset)
      .replace(':quesOffset', quesOffset ? parseInt(quesOffset) + 1 : 1)
      .replace(':isNegative', isNegative)
      .replace(':timerStart', timerStart);
    this.context.router.push({
      pathname,
    });
  };

  addHighlight = async (text) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/addHighlightedText', data).then(
      async (res) => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async (id) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/deleteHighlightedText', data).then(
        async (res) => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getHighlightedText', data).then(
      async (res) => {
        // console.log('highlights ---------> ', res.questions);
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  setJustification = (e, index) => {
    console.log('e', e.target.name);
    const {
      target: { value, name },
    } = e;
    this.setState({
      [name]: value,
      displayError: false,
    });
  };

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //console.log('userAgent', userAgent);
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    console.log({ choice, questionId, selectedQuestionData });
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      // console.log('Print params ---------> ', this.props.params);
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) : null,
        caseno: this.props.params.caseno ? parseInt(this.props.params.caseno) : null,
        caseOffset: this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : null,
        // attemptedCases: JSON.stringify(attemptedGrading),
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThrough(choice);
    }
  };

  addStrikeThrough = async (choice) => {
    //console.log('inside call apiiiii', choice);
    const { selectedQuestionData } = this.state;
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
    };

    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/addStrikeThrough', data).then(
      async (res) => {
        //console.log('resssssssssssssssss', res);
        // this.setState({ showPopover: false });
        await this.getStrikedText();
        // clearSelection();
      },
    );
    // };
  };

  updateJustification = async (questionId) => {
    const {
      props: { params },
      state: { token, idname, justification1, justification2, userGrading },
    } = this;
    const { id, testid, quesOffset, caseno, caseOffset } = params;
    const userData = {
      token,
      idname,
      questionId,
      mock_id: id ? Number.parseInt(id) : null,
      id: testid ? Number.parseInt(testid) : null,
      offset: quesOffset ? Number.parseInt(quesOffset) : null,
      caseno: caseno ? Number.parseInt(caseno) : null,
      caseOffset: caseOffset ? Number.parseInt(caseOffset) : null,
      justification1,
      justification2,
      userGrading,
    };
    const result = await FD.callAPI(
      App_data.backend_api + '/cfa3CBTMockExams/updateUsersChoice',
      userData,
    );
    console.log({ result });

    const { userStatsData } = this.state;
    const usergrading =
      userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : {};
    usergrading[questionId] = userGrading;
    this.setState((prevState) => ({
      userStatsData: {
        ...prevState.userStatsData,
        gradings: JSON.stringify(usergrading),
      },
    }));
    this.checkAttemptedGrading(usergrading);

    // if (result.success) {
    //   this.getUserStats();
    // }
  };
  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      const {
        id,
        questiono,
        caseno,
        quesOffset,
        timer,
        testid,
        caseOffset,
        isNegative,
        timerStart,
      } = this.props.params;
      let pathname = this.gradeQuestionRoute
        .replace(':id', id)
        .replace(':caseno', caseno)
        .replace(':questiono', questiono)
        .replace(':timer', timer)
        .replace(':testid', testid)
        .replace(':caseOffset', caseOffset)
        .replace(':quesOffset', quesOffset)
        .replace(':isNegative', false)
        .replace(':timerStart', timerStart);
      this.context.router.push({
        pathname,
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });

    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      isNegative: this.props.params.isNegative,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserTimer', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  }

  submitTest = () => {
    const { questionsData } = this.state;
    this.setState({
      showFinishTestPopup: false,
    });
    // console.log('I am here for you ----------->');

    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserQuizStatus', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );

    const ansdata = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getrightAnswer', ansdata).then(
      (resp_count) => {
        // console.log('I am here for you ----------->');
        if (resp_count.success) {
          const data = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            score: resp_count.allrightanswercount.question_count,
            id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
          };
          FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserScore', data);
        } else {
          //console.log(resp_count.success + '------------failure');
        }
      },
    );

    const { id, timer, testid } = this.props.params;
    let pathname = this.finishTestRoute
      .replace(':id', id)
      .replace(':caseno', 0)
      .replace(':questiono', 1)
      .replace(':testid', testid)
      .replace(':caseOffset', 0)
      .replace(':quesOffset', 0)
      .replace(':timer', timer);

    this.context.router.push({
      pathname,
    });
  };

  flagQuestion = (data) => {
    const { flag } = this.state;
    let flaggedQuestions = flag.filter((flag) => flag.question_id === data.id)[0];
    const flagdata = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: data.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    if (flaggedQuestions) {
      showSuccess('Question Unflagged');
    } else {
      showSuccess('Question Flagged');
    }
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/flagQuestion', flagdata).then(
      async (res) => {
        if (res) {
          this.getFlagQuestions();
        }
      },
    );
  };

  updateAttemptedGrading = (caseId) => {
    const userData = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      attemptedGrading: JSON.stringify([...this.state.attemptedGrading, caseId]),
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateAttemptedCases', userData).then(
      async (res) => {
        if (res.success) {
          this.setState({
            attemptedGrading: [...this.state.attemptedGrading, caseId],
          });
        }
      },
    );
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getflaggedQuestions', data).then(
      async (res) => {
        if (res) {
          this.setState({ flag: res.data, isLoading: false });
        }
      },
    );
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter((item) => item !== type);
      this.setState({
        filter: prevArray,
      });
    }
  };

  finishTest = () => {
    const { flag, userStatsData, totalQuestionCount } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';

    this.setState({ showFinishTestPopup: true });
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  stopTimer = () => {
    const { timerStart } = this.state;
    if (timerStart === 'true') {
      this.setState({
        timerStart: 'false',
      });
      const {
        id,
        questiono,
        caseno,
        quesOffset,
        timer,
        testid,
        caseOffset,
        isNegative,
        timerStart,
      } = this.props.params;
      let pathname = this.gradeQuestionRoute
        .replace(':id', id)
        .replace(':caseno', caseno)
        .replace(':questiono', questiono)
        .replace(':timer', timer)
        .replace(':testid', testid)
        .replace(':caseOffset', caseOffset)
        .replace(':quesOffset', quesOffset)
        .replace(':timerStart', false)
        .replace(':isNegative', isNegative);

      this.context.router.push({
        pathname,
      });
      clearInterval(this.timer);
    } else {
      this.setState({
        timerStart: 'true',
      });
      const {
        id,
        questiono,
        caseno,
        quesOffset,
        timer,
        testid,
        caseOffset,
        isNegative,
        timerStart,
      } = this.props.params;
      let pathname = this.gradeQuestionRoute
        .replace(':id', id)
        .replace(':caseno', caseno)
        .replace(':questiono', questiono)
        .replace(':timer', timer)
        .replace(':testid', testid)
        .replace(':caseOffset', caseOffset)
        .replace(':quesOffset', quesOffset)
        .replace(':timerStart', true)
        .replace(':isNegative', isNegative);

      this.context.router.push({
        pathname,
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter((item) => {
          return item.text === text;
        })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getStrikedText', data).then(
      async (res) => {
        if (res && res.questions) {
          this.setState({
            strikeThroughArr: JSON.parse(res.questions.choiceArray),
          });
        } else {
          this.setState({
            strikeThroughArr: [],
          });
        }
      },
    );
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      //console.log('heyyyyyyyyyyyyyyyy', sel);
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThrough(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = (e) => {
    clearTimeout(this.longPressCountdown);
  };
  updateUserAnswer = (answer, questionId, selectedCaseQuestionData) => {
    const {
      props: { params },
      state: { token, idname },
    } = this;
    const { id, testid } = params;
    const userData = {
      token,
      idname,
      question_id: questionId,
      reading_id: selectedCaseQuestionData.chapter_id,
      mock_id: id ? Number.parseInt(id) : null,
      test_id: testid ? Number.parseInt(testid) : null,
      user_grading: this.state.userGrading,
      max_grading: selectedCaseQuestionData.max_grading,
      answer,
    };
    FD.callAPI(
      `${App_data.backend_api}/${
        this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams'
      }/updateUserAnswer`,
      userData,
    ).then(async (res) => {});
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
        disableNavigationButtons: false,
      },
      () => {
        const { selectedCaseQuestionData } = this.state;

        if (name === 'userGrading') {
          this.updateJustification(selectedCaseQuestionData.id);
          if (value > 0) {
            this.updateUserAnswer('correct', selectedCaseQuestionData.id, selectedCaseQuestionData);
          } else {
            this.updateUserAnswer(
              'incorrect',
              selectedCaseQuestionData.id,
              selectedCaseQuestionData,
            );
          }
        }
      },
    );
  };

  checkAttemptedGrading = (usergrading) => {
    const { questionsData, attemptedGrading } = this.state;
    const parseResult = Object.keys(usergrading).map(function (x) {
      return parseInt(x, 10);
    });
    let count = 0;
    parseResult.forEach((element) => {
      let attemptedCount = questionsData.filter((item) => {
        if (item.id === element) {
          count++;
          if (questionsData.length === count) {
            if (attemptedGrading.indexOf(item.case_id) === -1) {
              this.updateAttemptedGrading(item.case_id);
            }
          }
        }
        return item.id === element;
      });
    });
  };
  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      filter,
      selectedQuestionData,
      seconds,
      selectedIndex,
      timerStart,
      highlights,
      strikeThroughArr,
      casesData,
      attemptedGrading,
      selectedCaseQuestionData,
    } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    let justification =
      userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
    let usergrading =
      userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);
    // let flaggedQuestion = flag.filter(flag => flag.question_id === selectedCaseQuestionData.id)[0];
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    const topSliderSettings = caseCV(
      this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1,
    );
    let content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
    if (highlights) {
      highlights.forEach((element) => {
        content = highlightString(content, element.text);
      });
    }
    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;
    return (
      <div>
        <div className='animated fadeIn'>
          {isLoading ? (
            <Loader />
          ) : (
            <div
              className={
                casesData
                  ? casesData.length < 15
                    ? 'margin_bottom_20 ques-title-wrapper pl-0'
                    : 'margin_bottom_20 ques-title-wrapper'
                  : null
              }
            >
              <h1 className='section_head'>{mockName}</h1>
              <div className='finish-btn-wrapper'>
                <Button onClick={() => this.finishTest()} className='pointer_class btn-primary'>
                  {'Finish Test'}
                </Button>
              </div>
            </div>
          )}
          {isLoading ? (
            <Loader />
          ) : casesData && casesData.length ? (
            <div>
              <div className='row'>
                <div className='col-md-12'>
                  <div
                    className={
                      casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
                    }
                  >
                    <Slider
                      {...topSliderSettings}
                      ref={(slider) => {
                        this.slider = slider;
                      }}
                    >
                      {casesData.map((item, index) => {
                        return (
                          <button
                            key={index}
                            onClick={() => this.changeCase(item.id, index)}
                            className={`
                              ${
                                index === parseInt(this.props.params.caseOffset)
                                  ? 'active button-trial'
                                  : 'button-trial'
                              }
                              
                              ${
                                attemptedGrading.indexOf(item.id) !== -1
                                  ? 'bg-completed-essay-cases'
                                  : `bg-completed-cases`
                              }`}
                          >
                            {index + 1}
                          </button>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
                <div className='' />
                <div className='case-detail-wrapper col-md-12'>
                  {selectedQuestionData && selectedQuestionData.case ? (
                    <div className='ques-wrapper all-ques'>
                        {renderHTMLContent(
                          selectedQuestionData.case_name,
                          "h1",
                          "mb-2 text-capitalize"
                        )}
                    </div>
                  ) : null}
                </div>
              </div>

              <Col>
                <div className='row '>
                  <div className='qus-tab-wrapper'>
                    {questionsData.map((item, index) => {
                      let flaggedQuestions = flag.filter((flag) => flag.question_id === item.id)[0];

                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                            ${index === parseInt(this.props.params.quesOffset) ? 'active' : ''}
                            ${
                              usergrading[item.id]
                                ? 'selected-grading'
                                : userChoice[item.id]
                                  ? 'completed-qus'
                                  : ''
                            }
                            ${flaggedQuestions ? 'flag-add' : ''}
                            `}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                  <div className='ques-detail-wrapper col-md-12 question-wrapper pr-0'>
                    <div className='card'>
                      <div className='card-block'>
                        <div className='row'>
                          <div className={'main_loader ' + this.state.display_main_loader}>
                            <div className='loader-mid'>
                              <div className='card-block-loader'>
                                <Loader />
                              </div>
                            </div>
                          </div>
                          <Col lg={12} md={12}>
                            <Col xs='12' sm='12' lg='12'>
                              <p>
                                <img
                                  src={
                                    App_data.frontend_url +
                                    '/img/question_bank/question_icon_blue.svg'
                                  }
                                  className='margin_right_20'
                                  alt=''
                                  width='30'
                                />
                                Q.
                                {parseInt(this.props.params.quesOffset) + 1}
                              </p>
                            </Col>
                            <ViewEssayQuestions
                              {...this.state}
                              {...selectedCaseQuestionData}
                              clickOption={this.clickOption}
                              selectedCaseQuestionData={selectedCaseQuestionData}
                              userChoice={userChoice}
                              justification={justification}
                              setJustification={this.setJustification}
                              justification1={this.state.justification1}
                              justification2={this.state.justification2}
                              disabledTextArea={true}
                              disabledChoices={true}
                              selectedIndex={selectedIndex}
                            />
                          </Col>
                          <div
                            className={`col-sm-6 d-sm-flex align-items-end text-center text-sm-left`}
                          >
                            {/* <button
                              className='menu-btn tooltip-hover-questions'
                              onClick={() => {
                                this.setState({
                                  showSectionReview: true,
                                });
                              }}
                            >
                              <img
                                width='30px'
                                src={
                                  App_data.frontend_url +
                                  '/img/questions/icon_menu.png'
                                }
                                className='my-1'
                              />
                              <div className='tootip_box'>
                                {language.LC().SECTION_REVIEW}
                              </div>
                            </button> */}
                          </div>
                          <div className='col-sm-6'>
                            <div className='text-center text-sm-right btm-btn-wrapper quiz-submit-block'>
                              <Button
                                onClick={() =>
                                  this.getPreviousQuestion(this.props.params.quesOffset)
                                }
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.quesOffset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>
                              <Button
                                onClick={() => this.getNextQuestion(this.props.params.quesOffset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.quesOffset) ===
                                  questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ViewAnswer
                      {...selectedCaseQuestionData}
                      handleChange={this.handleChange}
                      selectedChoice={
                        (userChoice[selectedCaseQuestionData.id] &&
                          selectedCaseQuestionData[userChoice[selectedCaseQuestionData.id]]) ||
                        ''
                      }
                      userGrading={
                        this.state.userGrading || usergrading[selectedCaseQuestionData.id] || ''
                      }
                    />
                  </div>
                </div>
              </Col>
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_GRADING}</p>
            </div>
          )}
        </div>
        {/* =========For Side Bar S============ */}
        <div className={`sidebar-review-wrapper ${showSectionReview ? 'active' : ''}`}>
          <div className='header-review'>
            <h2>{language.LC().SECTION_REVIEW}</h2>
            <span
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} />
            </span>
          </div>
          <div className='body-review'>
            <h4>{language.LC().FILTER_BY}:</h4>
            <div className='filt-list-wrapper'>
              <button
                className='btn btn-primary small-btn'
                onClick={() => {
                  this.setState({
                    filter: [],
                  });
                }}
              >
                {language.LC().CLEAR}
              </button>
              <ul>
                {filterObj.map((item, index) => {
                  return (
                    <li className='plan_wrapper remove-plan' key={index}>
                      <label className='check_container'>
                        <input
                          type='checkbox'
                          value={item}
                          id={item}
                          checked={filter.indexOf(item) > -1 ? true : false}
                          onChange={(e) => this.changeFilter(e, item)}
                        />
                        <span className='checkmark' /> {item}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='qus-tab-wrapper'>
              {questionsData.map((item, index) => {
                let flaggedQuestions = flag.filter((flag) => flag.question_id === item.id)[0];
                return (
                  <div key={index}>
                    {filter.includes('Attempted') &&
                    filter.includes('Unattempted') &&
                    filter.includes('Flagged') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                          flaggedQuestions ? 'flag-add' : ''
                        }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    ) : filter.includes('Attempted') && filter.includes('Unattempted') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''}`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                      </Button>
                    ) : filter.includes('Unattempted') && filter.includes('Flagged') ? (
                      !userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={` ${flaggedQuestions ? 'flag-add' : ''}`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : ///
                    filter.includes('Attempted') && filter.includes('Flagged') ? (
                      userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                            flaggedQuestions ? 'flag-add' : ''
                          }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Attempted') ? (
                      userChoice[item.id] ? (
                        <Button
                          className={'completed-qus'}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Unattempted') ? (
                      !userChoice[item.id] ? (
                        <Button
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : filter.includes('Flagged') ? (
                      flaggedQuestions ? (
                        <Button
                          className={`${
                            userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '
                          }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}

                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        </Button>
                      ) : (
                        ''
                      )
                    ) : (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${
                          flaggedQuestions ? 'flag-add' : ''
                        }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* =========For Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFA3GradeQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/GradeQuestion/index.js